// const Base__URL = 'https://yummycodes.herokuapp.com/api'
// const Base__URL = ' https://yummy-codes-app.herokuapp.com/api'
// const Base__URL = ' https://yummycodesuk.herokuapp.com/api'
// const Base__URL = 'https://ycuk.herokuapp.com/api'
// const Base__URL = 'https://ycuk-dev.herokuapp.com/api'
// const Base__URL = 'http://3.8.94.60/api'
// const Base__URL = 'https://yummycodesapi.co.uk/api'
export const Base__URL = 'https://yummycodesapi.co.uk/stage/api'



export const UPDATE_MERCHANT_ACCOUNT = `${Base__URL}/merchant/account`
export const UPDATE_MERCHANT_CONTACT = `${Base__URL}/merchant/contact`



export const ADD_MERCHANT = `${Base__URL}/merchant/register`
export const GET_MERCHANT = `${Base__URL}/merchant`
export const GET_MERCHANT_BY_ID = `${Base__URL}/merchant`
export const DELETE_MERCHANT = `${Base__URL}/merchant`
export const MERCHANT_STATUS = `${Base__URL}/merchant`
export const VERIFY__MERCHANT = `${Base__URL}/merchant/id`
export const UPDATE_MERCHANT = `${Base__URL}/merchant/info`

export const GET_RESTAURENTS = `${Base__URL}/restaurant`
export const ADD_RESTAURENTS = `${Base__URL}/restaurant`
export const DELETE_RESTAURENTS_API = `${Base__URL}/restaurant`
export const RESTAURENTS_STATUS = `${Base__URL}/restaurant`
export const UPDATE_RESTAURENTS = `${Base__URL}/restaurant`
export const RESTAURENTS_APPROVE = `${Base__URL}/restaurant/approve`
export const DELETE_BANNER_IMAGE = `${Base__URL}/restaurant/deleteimage`

export const GET_DEALS = `${Base__URL}/product/admin/deal`
export const APPROVE_DEALS = `${Base__URL}/product`
export const EXPIRE_DEAL = `${Base__URL}/product/expire`
export const ADD_DEAL = `${Base__URL}/product/admin`
export const GET_TRANSACTIONS = `${Base__URL}/paymentlogs`
export const GET_TRANSACTIONS_BY_ID = `${Base__URL}/paymentlogs`

export const BLOCK_DEAL = `${Base__URL}/product/block`
export const UNBLOCK_DEAL = `${Base__URL}/product/block`

export const UPDATE_DEAL = `${Base__URL}/product`
export const DELETE_DEAL_API = `${Base__URL}/product`
export const GET_DEALS_BY_ID = `${Base__URL}/product`


export const GET_PROMOTED_DEAL_API = `${Base__URL}/promotion`
export const ADD_PROMOTED_DEAL_API = `${Base__URL}/promotion`
export const UPDATE_PROMOTED_DEAL_API = `${Base__URL}/promotion`
export const DELETE_PROMOTED_DEAL_API = `${Base__URL}/promotion`

export const GET_MENU = `${Base__URL}/product/admin/menu`
export const ADD_MENU = `${Base__URL}/product/admin`
export const UPDATE_MENU = `${Base__URL}/product/menuitem`

export const GET_ORDERS = `${Base__URL}/order`
export const GET_ORDERS_BY_ID = `${Base__URL}/order`
export const CANCEL_ORDER = `${Base__URL}/order`
export const COMPLETE_ORDER = `${Base__URL}/order/accept`
export const GET_ANALYTICS = `${Base__URL}/product/analytics/merchant`



// variable
export const ALL_MERCHANTS = 'ALL_MERCHANTS'
export const DELETE_MERCHANTS = 'DELETE_MERCHANTS'
export const MENU_RESPONSE = 'MENU_RESPONSE'


export const ALL_RESTAUTRENTS = 'ALL_RESTAUTRENTS'
export const DELETE_RESTAUTRENTS = 'DELETE_RESTAUTRENTS'

export const GET_ALL_DEALS = 'GET_ALL_DEALS'
export const DELETE_DEALS = 'DELETE_DEALS'

export const GET_PROMOTED_DEALS = 'GET_PROMOTED_DEALS'
export const GET_DELETED_PROMOTED_DEALS = 'GET_DELETED_PROMOTED_DEALS'

export const GET_ALL_ORDERS = 'GET_ALL_ORDERS'
